












































import {
  computed,
  defineComponent,
  getCurrentInstance
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

const selectorsCount = 5;

export default defineComponent({
  name: "Pagination",
  components: {
    OccHeading
  },
  props: {
    current: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["change"],
  setup(props, { emit }) {
    const selectors = computed(() => {
      if (props.total < selectorsCount) {
        return [...Array(props.total)].map((_, i) => i + 1);
      }

      const middle = Math.round(selectorsCount / 2);

      let start: number;
      if (props.current < middle) {
        start = 1;
      } else if (props.total - props.current < middle) {
        start = props.total - selectorsCount + 1;
      } else {
        start = props.current - (middle - 1);
      }

      return [...Array(selectorsCount)].map((_, i) => start + i);
    });

    const showFirsPageSelector = computed(() => {
      return !selectors.value.includes(1);
    });

    const showLastPageSelector = computed(() => {
      return !selectors.value.includes(props.total);
    });

    const instance = getCurrentInstance();
    const onChange = (pageNumber: number) => {
      const nextPageNumber = Math.min(Math.max(1, pageNumber), props.total);
      if (nextPageNumber === props.current) {
        return;
      }

      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_ページネーション`,
          gaEventLabel: { value: nextPageNumber }
        });
      }

      emit("change", nextPageNumber);
    };

    return {
      selectors,
      showFirsPageSelector,
      showLastPageSelector,
      onChange
    };
  }
});
